<template>
  <svg
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M11.3 2V5.3a3.3 3.3 0 0 0-6.6 0v1.4m3.3 3V11m-2.1 3H10c1.2 0 1.7 0 2.1-.2.4-.2.7-.5 1-.9l.1-2.1v-1c0-1 0-1.6-.2-2a2 2 0 0 0-.9-1l-2-.1H5.8c-1.2 0-1.7 0-2.1.2a2 2 0 0 0-1 .9l-.1 2v1c0 1.1 0 1.7.2 2.1.2.4.5.7.9.9.4.2 1 .2 2 .2Z"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  /></svg>
</template>
